import http from '../http'
import { Res } from '../type'
import {
  WaybillPageResult,
  WaybillQuery
} from '@/model/cancelUpload/cancelUpload'
export const getList = (data: WaybillQuery): Res<WaybillPageResult> => {
  return http.request({
    url: '/platformCancel/query',
    method: 'post',
    loadingShow: '0',
    data
  })
}
